var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import clsx from 'clsx';
import React from 'react';
import './UiText.css';
export function UiText(_a) {
    var className = _a.className, children = _a.children, rest = __rest(_a, ["className", "children"]);
    var classNames = ['align', 'size', 'weight', 'color', 'transform', 'noWrap'].map(function (key) { return rest[key] && key + "-" + rest[key]; });
    return React.createElement("div", { className: clsx('UiText', className, classNames) }, children);
}
